export default "__VITE_ASSET__rgjAe3RA__"